import React from 'react';
import { useSelector } from 'react-redux';

import MenuUser from 'components/MenuUser/MenuUser';

const formatFirstName = ( name, isLoading ) => {
    let firstName = '';
    if (!isLoading) {
        if (name) {
            const { value } = name;
            const nameArray = value.split(' ');
            firstName = nameArray[0];
        }
    }
    return firstName;
}

const HeaderProfile = () => {
    const CmsStatic = useSelector(({ CmsStatic: data }) => data);
    const Participants = useSelector(({ Participants: data }) => data);

    const { cms: { headerMenu }, isLoading: isLoadingCms } = CmsStatic;
    const { name, isLoading: isLoadingParticipant  } = Participants;
    const isLoading = isLoadingParticipant || isLoadingCms;

    return (
        <MenuUser isLoading={isLoading} userName={formatFirstName(name, isLoading)} items={headerMenu && headerMenu.items} />
    );
};

export default HeaderProfile;
